import React from 'react';

interface Props {
    thick?: boolean;
    smallerMargin? : boolean;
}

const HorizontalDivider = (props: Props) => (
    <div className={props.thick ? "divider-thick" : props.smallerMargin ? "divider-smaller-margin" : "divider"}></div>
);

export default HorizontalDivider;
